import { useTranslation } from 'react-i18next';
import { Button, Flex } from 'antd';

import pdf from 'assets/images/pdf.png';

interface FileInputProps {
	name: string;
	data?: string;
	downloadLink?: string;
	onDownload?: () => void;
	className?: string;
	transparent?: boolean;
	disabled?: boolean;
	disableText?: string;
}

function FilePreview({ name, data, className, transparent, onDownload, downloadLink, disabled, disableText }: FileInputProps) {
	const { t } = useTranslation();

	const onDownloadFile = async () => {
		if (downloadLink) {
			await downloadFile(downloadLink, name);
		}

		onDownload?.();
	};

	const downloadFile = async (url: string, filename: string) => {
		fetch(url)
			.then((response) => response.blob())
			.then((blob) => {
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = filename;
				document.body.appendChild(link);
				link.click();
				link.remove();
				URL.revokeObjectURL(link.href);
			})
			.catch((err) => console.error('Download failed:', err));
	};

	return (
		<Flex
			justify="space-between"
			align="center"
			className={`${!transparent && 'p-3'} ${className}`}
			style={
				transparent
					? {}
					: {
							border: '1px dashed rgb(137, 188, 246)',
							borderRadius: 8,
							background: 'rgba(0,0,0,0.02)',
							cursor: disabled ? 'not-allowed' : 'default',
					  }
			}>
			<Flex align="center" gap={10}>
				<img src={pdf} width={40} />
				<div>
					<p className="mb-0">{name}</p>
					{data && <span className="text-light">{data}</span>}
				</div>
			</Flex>

			{downloadLink && (
				<Button onClick={onDownloadFile} type="primary" size="middle">
					{t('COMMON.DOWNLOAD')}
				</Button>
			)}

			{disabled && <span>{disableText || t('ACTIONS.NOT_READY_YET')}</span>}
		</Flex>
	);
}

export default FilePreview;
